import Network from '../lib/network';

const api = Network();

const path = resource => {
  if (!resource) resource = '';
  return { resource: 'api/' + resource };
}

export const getIndustryTypes = str => {
  return api.get(path(`industries?description=${str}`))
};